module.exports = __webpack_public_path__ + "img/1218339383.557be15f.jpg";